/**
 * 프로필 이미지 처리 유틸리티
 */

/**
 * 사용자 프로필 이미지 URL을 반환합니다.
 * 카카오톡 프로필 이미지가 있으면 우선 사용하고, 없으면 null을 반환하여 기본 프로필(닉네임 첫 글자)을 사용합니다.
 * @param {Object} user - 사용자 객체
 * @returns {string|null} - 프로필 이미지 URL 또는 null
 */
export function getProfileImageUrl(user) {
  if (!user) return null

  // 카카오 프로필 이미지가 있고 유효한 URL인지 확인
  if (user.profileImage && user.profileImage.trim() !== '') {
    // URL 형식 검증
    try {
      new URL(user.profileImage)
      return user.profileImage
    } catch (e) {
      return null // 렌더마다 불리는 함수라 경고를 찍지 않는다 — 목록 하나에 수십 줄이 쌓였다
    }
  }

  return null
}

/**
 * 사용자 닉네임의 첫 글자를 반환합니다 (기본 프로필용)
 * @param {Object} user - 사용자 객체
 * @returns {string} - 닉네임 첫 글자
 */
export function getProfileInitial(user) {
  if (!user || !user.nickname) return '?'
  return user.nickname.charAt(0).toUpperCase()
}

/**
 * 등급 라벨 · tone-chip 수식 클래스. 관리자 화면과 프로필 화면이 각자 한 벌씩 들고 있었고,
 * 같은 사람의 같은 등급이 두 화면에서 다른 색으로 뜬 적이 있다.
 * 앰버는 앱 전체에서 '대기 · 임박' 이라 등급에 쓰지 않는다. 1(외부인)은 수식 없이 기본 회색 칩.
 */
const GRADE = {
  4: { label: '개발자', tone: 'tone-chip--danger' },
  3: { label: '중요관리자', tone: 'tone-chip--primary' },
  2: { label: '관리자', tone: 'tone-chip--success' }
}
export const gradeLabel = (grade) => GRADE[grade]?.label || '외부인'
export const gradeTone = (grade) => GRADE[grade]?.tone || ''
